import { StandardGamepadAxisIndex, StandardGamepadButtonIndex } from "@/interfaces/virtualPad_types";
import { VPadP2PAxis, VPadP2PKeyCodes } from "./p2p_types";

/**
 * Maps P2P virtual gamepad key codes to their corresponding
 * standard Gamepad API button indexes
 */
export const VPAD_KEY_CODE_TO_BUTTON_INDEX: Record<
  VPadP2PKeyCodes,
  StandardGamepadButtonIndex
> = {
  [VPadP2PKeyCodes.A]: StandardGamepadButtonIndex.A,
  [VPadP2PKeyCodes.B]: StandardGamepadButtonIndex.B,
  [VPadP2PKeyCodes.X]: StandardGamepadButtonIndex.X,
  [VPadP2PKeyCodes.Y]: StandardGamepadButtonIndex.Y,

  [VPadP2PKeyCodes.L1]: StandardGamepadButtonIndex.L1,
  [VPadP2PKeyCodes.R1]: StandardGamepadButtonIndex.R1,
  [VPadP2PKeyCodes.L2]: StandardGamepadButtonIndex.L2,
  [VPadP2PKeyCodes.R2]: StandardGamepadButtonIndex.R2,

  [VPadP2PKeyCodes.SELECT]: StandardGamepadButtonIndex.SELECT,
  [VPadP2PKeyCodes.START]: StandardGamepadButtonIndex.START,
  [VPadP2PKeyCodes.L3]: StandardGamepadButtonIndex.L3,
  [VPadP2PKeyCodes.R3]: StandardGamepadButtonIndex.R3,

  [VPadP2PKeyCodes.ARROW_UP]: StandardGamepadButtonIndex.ARROW_UP,
  [VPadP2PKeyCodes.ARROW_DOWN]: StandardGamepadButtonIndex.ARROW_DOWN,
  [VPadP2PKeyCodes.ARROW_LEFT]: StandardGamepadButtonIndex.ARROW_LEFT,
  [VPadP2PKeyCodes.ARROW_RIGHT]: StandardGamepadButtonIndex.ARROW_RIGHT,

  [VPadP2PKeyCodes.HOME]: StandardGamepadButtonIndex.HOME,
}

/**
 * Maps P2P virtual joystick identifiers to their corresponding
 * horizontal and vertical Gamepad API axis indexes.
 */
export const VPAD_AXIS_TO_GAMEPAD_AXES: Record<
  VPadP2PAxis,
  readonly [
    horizontal: StandardGamepadAxisIndex,
    vertical: StandardGamepadAxisIndex,
  ]
> = {
  [VPadP2PAxis.LEFT]: [
    StandardGamepadAxisIndex.LEFT_HORIZONTAL,
    StandardGamepadAxisIndex.LEFT_VERTICAL,
  ],

  [VPadP2PAxis.RIGHT]: [
    StandardGamepadAxisIndex.RIGHT_HORIZONTAL,
    StandardGamepadAxisIndex.RIGHT_VERTICAL,
  ],
}